import { UIComponentImpl, UIComponentProps, UIComponentHandler, UIComponentState, UIDataModel } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { RepeatCardSettingViewImpl } from './repeatcardsettingview';
import { RepeatCardSettingCSSStyleImpl } from './repeatcardsettingcss';

export interface RepeatCardSettingComponentProps extends UIComponentProps
{
   title :string;
   id:string;
   isSelected:boolean;
   onRepeatClick(id:string, isSelected:boolean):void;
}
 
export interface RepeatCardSettingComponentState extends UIComponentState
{
    isSelected:boolean;

}
export interface RepeatCardSettingComponentHandler extends UIComponentHandler
{
   onRepeatClick():void;

}

export class RepeatCardSettingComponent extends UIComponentImpl<RepeatCardSettingComponentProps, RepeatCardSettingComponentState, UIDataModel> implements RepeatCardSettingComponentHandler
{
    constructor(props: RepeatCardSettingComponentProps)
    {
        super(props);
        this.state = {isSelected:props.isSelected};
    }
   

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new RepeatCardSettingViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new RepeatCardSettingCSSStyleImpl(applicationContext);
    }

    componentWillReceiveProps(nextProps: RepeatCardSettingComponentProps)
    {
        this.setState({isSelected: nextProps.isSelected});
    }

    onRepeatClick(): void 
    {
          this.setState({isSelected:!this.state.isSelected});
           this.props.onRepeatClick(this.props.id, !this.state.isSelected);
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/repeatcardsetting/repeatcardsettingcomponent.tsx